import Entities from 'STORE';

export function handleForceUpdate(property) {
  const hasForceUpdate = Boolean(property) && property.value === 'true';

  if (hasForceUpdate) {
    Entities.authStore.setForceUpdate(true);
  }
}
